import { Permission } from '@shared/types/global.types'
import { create } from 'zustand'
import type { AuthState } from '../types/auth.types'

export const useAuthStore = create<AuthState>()((set, get) => ({
  user: null,
  isAuthenticated: false,
  sessionEnded: false,

  setUser: (user) => {
    set({ user, isAuthenticated: Boolean(user), sessionEnded: false })
  },

  logout: () => {
    set({ user: null, isAuthenticated: false, sessionEnded: true })
  },

  hasPermission: (permission: Permission) => {
    return get().user?.permissions.includes(permission) ?? false
  },

  canPublish: () => get().hasPermission(Permission.PUBLISH),
  canViewAnalytics: () => get().hasPermission(Permission.VIEW_ANALYTICS),
}))
